import injectSheet from 'react-jss'
import Tag from './Tag'
import styles from './Tag.styles'

export default injectSheet(styles)(Tag)
